// frontend/src/components/SDR/SdrSessionsPanel.jsx
import React from 'react';
import { useQuery } from 'react-query';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { getContactSdrSessions } from '../../services/api';
import SessionCard from './SessionCard';

const SdrSessionsPanel = ({ contactId }) => {
  const { data: sessions, isLoading, isError } = useQuery(
    ['sdr-sessions', contactId],
    () => getContactSdrSessions(contactId),
    { enabled: !!contactId }
  );
  if (isLoading || isError) return null;
  if (!sessions || sessions.length === 0) return null;
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <ChatBubbleLeftRightIcon className="h-5 w-5 text-slate-600" />
        <h3 className="text-lg font-semibold text-gray-800">Entrevista SDR {sessions.length > 1 ? `(${sessions.length})` : ''}</h3>
      </div>
      {sessions.map((s) => <SessionCard key={s.id} s={s} />)}
    </div>
  );
};

export default SdrSessionsPanel;
